import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectObjectiveOperational } from "../Model/ProposalProjectObjectiveOperational";

export async function getProposalProjectObjectiveOperational(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-objective-operational/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectObjectiveOperational = response.map(data => ProposalProjectObjectiveOperational.createFromResponseData(data));
	return proposalProjectObjectiveOperational;
}
